<div>
    <div class="col-lg-12">
        <div class="row" class = "header-wrapper">
            <ng-content select = "[headerContent]"></ng-content>
        </div>
        <div class="split-frame-container">
                <as-split class="col-lg-12"  direction="horizontal" style="padding-right: 0px;">
                    <as-split-area class="col-lg-6" [size]="50">
                        <as-split direction="vertical" class="col-lg-12">
                            <ng-content select = "[leftContent]"></ng-content>
                        </as-split>
                    </as-split-area>
                    <as-split-area  [size]="50" class="col-lg-6">
                        <as-split direction="vertical" class="col-lg-12">
                            <ng-content select = "[rightContent]"></ng-content>
                        </as-split>
                    </as-split-area>
                </as-split>
        </div>
    </div>
</div>
